import PatientsContainer from './patients-container';

export default PatientsContainer;